import { Box } from '@mui/material';
import { Menu } from 'react-admin';
import HeaderNotifications from './Notifications';

function HeaderButtons() {
  return (
    <Box>
      {/* <HeaderNotifications /> */}
    </Box>
  );
}

export default HeaderButtons;
